/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_SubtotalInputs */

const vi_order_subtotal = /** @type {(inputs: Order_SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tiền`)
};

/**

* @param {Order_SubtotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_subtotal = /** @type {((inputs?: Order_SubtotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_SubtotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_subtotal(inputs)
});